export var doesExistInArray = function() {
    var items = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], lookup = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], key = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    return items.some(function(item) {
        return lookup.includes(key ? item === null || item === void 0 ? void 0 : item[key] : item);
    });
};
